import { titleCase } from 'change-case';

// Helper to check if a string is a MongoDB ID (24-char hex string)
const isMongoId = (str) => /^[a-f0-9]{24}$/i.test(str);

// Helper to check if a string is a UUID
const isUuid = (str) => /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(str);

// Helper to clean path segments
const cleanPathSegment = (segment) => {
  // Remove MongoDB IDs and UUIDs from path
  if (isMongoId(segment) || isUuid(segment)) return null;

  // Clean up common patterns
  segment = segment.replace(/-/g, ' ');
  segment = segment.replace(/_/g, ' ');

  return titleCase(segment);
};

export default {
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [{ property: 'og:title', content: this.metaTitle, vmid: 'og:title' }]
    };
  },
  computed: {
    baseMetaTitle() {
      // Allow components to define their own page title
      if (this.pageTitle) {
        return this.pageTitle;
      }

      // Build title from route path, excluding IDs
      const pathSegments = this.$route.path
        .split('/')
        .filter((path) => !!path)
        .map(cleanPathSegment)
        .filter((segment) => segment !== null);

      // Remove duplicate consecutive segments
      const uniqueSegments = pathSegments.filter((segment, index) => {
        if (index === 0) return true;
        return segment.toLowerCase() !== pathSegments[index - 1]?.toLowerCase();
      });

      return uniqueSegments.join(' | ');
    },
    metaTitle() {
      const company = 'MPower Promo Inc.';
      return this.baseMetaTitle ? `${this.baseMetaTitle} | ${company}` : company;
    }
  }
};
